<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="askQuestionModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="askQuestionModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="askQuestionModalLabel">
            {{ $t("label.askAQuestion") }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="needs-validation" novalidate id="questionForm">
            <div class="form-row">
              <input name="account_id" type="hidden" :value="account_id" />
              <div class="col-md-12 mb-6">
                <label for="name">{{ $t("label.name") }}</label>
                <input
                  name="name"
                  type="text"
                  class="form-control"
                  id="name"
                  required
                />
                <div class="invalid-feedback">{{ $t("error.name") }}</div>
              </div>
              <div class="col-md-12 mb-6">
                <label for="email">{{ $t("label.email") }}</label>
                <input
                  name="email"
                  type="email"
                  class="form-control"
                  id="email"
                  required
                />
                <div class="invalid-feedback">{{ $t("error.email") }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-6">
                <label for="phone">{{ $t("label.phone") }}</label>
                <input
                  name="phone"
                  type="text"
                  class="form-control"
                  id="phone"
                  required
                />
                <div class="invalid-feedback">{{ $t("error.phone") }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-6">
                <label for="subject">{{ $t("label.subject") }}</label>
                <input
                  name="subject"
                  type="text"
                  class="form-control"
                  id="subject"
                  required
                />
                <div class="invalid-feedback">{{ $t("error.subject") }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-6">
                <label for="message">{{ $t("label.message") }}</label>
                <textarea
                  name="message"
                  class="form-control"
                  id="message"
                  required
                />
                <div class="invalid-feedback">{{ $t("error.message") }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" data-dismiss="modal">
                {{ $t("button.close") }}
              </button>
              <button @click.prevent="submitForm">
                {{ $t("button.sendMessage") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapState } from "vuex";
import MessagesService from "@/services/MessagesService";
import { get } from "lodash";
export default {
  mounted() {
    $("#askQuestionModal").on("hidden.bs.modal", () => {
      $("#questionForm")[0].classList.remove("was-validated");
      $("#questionForm")[0].reset();
    });
  },
  computed: {
    ...mapState({
      account_id: "church_account_id",
    }),
  },
  methods: {
    async submitForm() {
      const forms = $("#questionForm");
      let isValid = true;
      Array.prototype.forEach.call(forms, function (form) {
        console.log(form.checkValidity());
        if (form.checkValidity() === false) {
          isValid = false;
        }
        form.classList.add("was-validated");
      });
      if (isValid) {
        const dataInput = $("#questionForm")
          .serializeArray()
          .reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
          }, {});
        try {
          await MessagesService.sendMessage({
            subject: dataInput.subject,
            account_id: this.$store.state.church_account_id,
            email: dataInput.email,
            phone: dataInput.phone,
            message: dataInput.message,
          });
          this.$toasted.success("Sent message successful").goAway(5000);
        } catch (error) {
          console.log({ error });
          this.$toasted
            .error(
              get(
                error,
                "response.data.error",
                "There is a problem in sending Messages"
              )
            )
            .goAway(5000);
        }
      }
      console.log(
        isValid,
        $("#questionForm")
          .serializeArray()
          .reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
          }, {})
      );
    },
  },
};
</script>
